import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("MediaPrivateOutput")
export class MediaPrivateOutput {
    @JsonProperty("status", Boolean)
    public status: boolean = JsonPropertyEmpty;
}
